import { SessionStorageKey } from '../enums/SessionStorageKey';

export function useUserEmail(): string {
  return sessionStorage.getItem(SessionStorageKey.Username)!;
}
